import { collection, addDoc, doc,  getDoc, updateDoc } from "firebase/firestore";
import { db, auth } from '../utils/firebase.js';
import { _getGroup } from './groups.js';
import { getFunctions, httpsCallable } from 'firebase/functions'; 


export const _addAsNewGroupMember = async (groupId, memberName) => {
    let newMember = {
        displayName: memberName,
        uid: auth.currentUser.uid
    }
    const groupMembersCollection = collection(db, "groups", groupId, "members");
    await addDoc(groupMembersCollection, newMember);
}

export const _claimMember = async (groupId, memberId, displayName) => {
    const memberRef = doc(db, "groups", groupId, "members", memberId);
    var memberData = { uid: auth.currentUser.uid }
    if (displayName) {
        memberData.displayName = displayName;
    }
    await updateDoc(memberRef, memberData);
}

export const _getGroupInvitation = async (invitationToken) => {
    try {
        const docRef = doc(db, 'liveInvites', invitationToken);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) {
            return null;
        }
        const data = docSnap.data();
        const dateObject = data['joinWindowExpiresOn'].toDate();
        const hours = dateObject.getHours() % 12 || 12;
        const minutes = dateObject.getMinutes().toString().padStart(2, '0');
        const ampm = dateObject.getHours() >= 12 ? 'PM' : 'AM';
        const hoursAndMinutes = `${hours}:${minutes} ${ampm}`;
        return {
            groupId: data['groupId'],
            groupName: data['groupName'],
            expires: hoursAndMinutes,
            groupHeader: data['groupHeader']
        };
    } catch (error) {
        return null;
    }
}

export const _tryJoinGroup = async (invitationId) => {
    const functionsInstance = getFunctions();
    const acceptInviteCallable = httpsCallable(functionsInstance, 'acceptGroupInvite');
    const result = await acceptInviteCallable({ token: invitationId });
    return result.data ?? { success: false };
}
